export default "est\nou\noù\nquoi\ncomment\ncombien\ndevrait\npeut"